export enum LinkDatasetRelationship {
    BIDIRECTIONAL = 'BIDIRECTIONAL',
    UNIDIRECTIONAL = 'UNIDIRECTIONAL'
}
